import { type LucideIcon } from 'lucide-react'
import { buildNavPathTrader } from '@klear/constants'

export type NavItem = {
  title: string
  permission?: string
  url: string
  icon?: LucideIcon
  items?: NavItem[]
  badge?: number
}
export function pathWithoutTraderId(pathname: string) {
  return pathname.split('/').slice(3)
}
export const pathMatchesItems = (pathname: string, traderId: string, ...navItems: string[]) => {
  return pathname.startsWith(buildNavPathTrader(traderId, ...navItems))
}
